<template>
  <div
    class="carousel-vertical"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave">
    <div class="banner-icon">
      <img src="../images/banner-icon.svg" alt="banner-icon" />
    </div>
    <!-- <i class="yinliang layout layout-tms-yinliangDisable banner-icon" /> -->
    <div
      :aria-hidden="currentIndex !== index"
      v-for="(item, index) in list"
      :key="item.id"
      class="carousel-vertical-item"
      :style="animationStyle"
      @click="handleClick(item)"
      :class="getItemCls(item, index)">
      <span class="notice-content">{{item.name}}</span>
    </div>
  </div>
</template>

<script>
  const animationStyle = {
    transitionTimingFunction: 'cubic-bezier(0.34, 0.69, 0.1, 1)',
    transitionDuration: `500ms`,
    animationTimingFunction: 'cubic-bezier(0.34, 0.69, 0.1, 1)',
    animationDuration: `500ms`,
  }
  export default {
    props: {
      list: Array
    },
    data() {
      return {
        // list: [],
        currentIndex: 0,
        previousIndex: undefined,
        animationStyle
      }
    },
    mounted () {
      this.startPlay()
    },
    beforeDestroy () {
      this.clearTimer()
    },
    methods: {
      getItemCls (item, index) {
        const prefixCls = 'carousel-vertical-item'
        const isCurrent = this.currentIndex === index
        const isPrev = this.previousIndex === index
        return {
          [`${prefixCls}-current`]: isCurrent,
          [`${prefixCls}-slide-in`]: isCurrent,
          [`${prefixCls}-slide-out`]: isPrev,
        }
      },
      slideTo(targetIndex) {
        if (!this.animationTimer && targetIndex !== this.currentIndex) {
          this.previousIndex = this.currentIndex
          this.currentIndex = targetIndex
          this.animationTimer = window.setTimeout(() => {
            this.animationTimer = 0
          }, 500)
        }
      },
      clearTimer () {
        if (this.intervalTimer) {
          window.clearInterval(this.intervalTimer)
          this.intervalTimer = null
        }
      },
      getValidIndex (i) {
        const indexNumber = +i
        const length = this.list.length
        if (length === 0) return 0
        return typeof indexNumber === 'number' && !Number.isNaN(indexNumber)
          ? (indexNumber + length) % length
          : i
      },
      startPlay () {
        this.clearTimer()
        this.intervalTimer = window.setInterval(() => {
          const nextIndex = this.getValidIndex(this.currentIndex + 1)
          this.slideTo(nextIndex)
        }, 5000)
      },
      handleMouseEnter () {
        this.clearTimer()
      },
      handleMouseLeave () {
        this.startPlay()
      },
      handleClick (item) {
        this.$emit('click', item)
      },
      handleCollapsed (index) {
        this.clearTimer()
        this.currentIndex = index
        this.startPlay()
      }
    }
  }
</script>

<style lang="scss" scoped>
.carousel-vertical {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  .banner-icon {
    position: absolute;
    display: block !important;
    visibility: visible !important;
    left: 12px;
    width: 36px;
    height: 24px;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 12px;
    background: rgba(243, 239, 254, 1);
    img {
      display: block;
      width: 12px;
      margin: 4px auto 0;
    }
  }
  @keyframes slideIn {
    from {
      transform: translateY(100%);
    }

    to {
      transform: translateY(0);
    }
  }

  @keyframes slideOut {
    from {
      transform: translateY(0);
    }

    to {
      transform: translateY(-100%);
    }
  }
  &-item {
    padding-left: 57px;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    .notice-content {
      height: 42px;
      line-height: 42px;
      font-size: 14px;
    }
    color: #333333;
    &-curerent {
      z-index: 1;
    }
    &-slide-out {
      display: block !important;
      animation: slideOut;
    }
    &-slide-in {
      display: block;
      animation: slideIn;
    }
  }
  > *:not(.carousel-vertical-item-current) {
    display: none;
    visibility: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/banner/vertical-carousel.vue